package com.essntl.components.multiselect

import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.positionInRoot
import androidx.compose.ui.unit.toSize

class SelectableItemState(
    val id: String,

    var size: Size = Size.Zero,
    var topLeft: Offset = Offset.Zero,
)

@Composable
fun Modifier.selectableItem(
    id: String,
    state: MultiSelectState,
): Modifier = composed {
    DisposableEffect(id) {
        onDispose {
            state.selectableItemMap.remove(id)
        }
    }

    onGloballyPositioned {
        val selectableItemState = SelectableItemState(
            id = id,
            size = it.size.toSize(),
            topLeft = it.positionInRoot(),
        )
        state.addSelectableItem(selectableItemState)
    }
}
